import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { locizeNS } from 'Services/i18n';
import { userStageSelector } from 'Store/modules/validations/selectors';
import { useTranslation } from 'Hooks/useTranslation';
import Arrow from 'Components/icons/Arrow';
import { handleSectionMenu } from 'Styles/utils/utils';
import { stages } from 'Constants/stages';
import * as Styled from './styles';
import { SectionsButtonProps } from './types';

const SectionsButton = ({ isFlow }: SectionsButtonProps): JSX.Element | null => {
  const { t } = useTranslation(locizeNS.VALIDATIONS);
  const userStage = useSelector(userStageSelector);
  const showSections = useMemo(() => isFlow && userStage !== stages.SUBMITTED, [isFlow, userStage]);
  const handleShowMenu = (): void => {
    handleSectionMenu();
  };
  if (showSections) {
    return (
      <Styled.BackButton onClick={handleShowMenu} id="section-handler">
        <Arrow />
        {t('Menu.sections')}
      </Styled.BackButton>
    );
  }
  return null;
};

export default SectionsButton;
